import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainContent from "components/Containers/MainContent";
import RequiredGearTable from "./components/RequiredGearTable";
import Dialog from "components/Dialog/Dialog";
import { Add } from "@mui/icons-material";
import { actions as RequiredGearActions, selectors as RequiredGearSelectors } from "store/modules/requiredGear";
import Button from "components/Button/Button";
import AddGearDialog from "./components/AddGearDialog";
import EditGearDialog from "./components/EditGearDialog";

function RequiredGearOverview() {

  const dispatch = useDispatch()
  const isdeleteDialog = useSelector(RequiredGearSelectors.getIsdeleteDialog);
  const [deleteGearId, setDeleteGearId] = useState(null);
  const [selectedGear, setSelectedGear] = useState(null);

  const createGear = () => {
    dispatch(RequiredGearActions.setIsaddGearDialog(true));
  }

  const showGearDeleteDialog = (id) => {
    dispatch(RequiredGearActions.setIsDeleteDialog(true));
    setDeleteGearId(id);
  }

  const showGearEditDialog = (gear) => {
    dispatch(RequiredGearActions.setIsEditGearDialog(true));
    setSelectedGear(gear);
  }

  const hideGearDeleteDialog = () => {
    dispatch(RequiredGearActions.setIsDeleteDialog(false));
  }

  const hideGearEditDialog = () => {
    setSelectedGear(null);
  }

  const handleDeleteGear = () => {
    dispatch(RequiredGearActions.deleteGear(deleteGearId));
    hideGearDeleteDialog();
  }

  return (
    <>
      <MainContent>
        <Button
          style={{ alignSelf: "flex-end", marginBottom: 24 }}
          label="Add"
          icon={<Add />}
          alignIcon="left"
          onClick={createGear}
        />
        <RequiredGearTable onDelete={showGearDeleteDialog} onEdit={showGearEditDialog} />
        <Dialog
          open={isdeleteDialog}
          title="Are you sure?"
          onClose={hideGearDeleteDialog}
          onConfirm={handleDeleteGear}
          onCancel={hideGearDeleteDialog}
          alertType="warning"
          icon="help_outline"
        />
      </MainContent>
      <AddGearDialog />
      <EditGearDialog gear={selectedGear} onHideEditDialog={hideGearEditDialog}/>
    </>
  )
}

export default RequiredGearOverview
